(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["menina-gallery-rail"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('menina-thumb-rail')) return;

    class MeninaThumbRail extends HTMLElement {
      connectedCallback() {
        const gallery = this.closest('media-gallery');
        if (!gallery) return;

        this.items = Array.from(gallery.querySelectorAll('.media-gallery__grid > li'));
        this.thumbs = Array.from(this.querySelectorAll('button[data-index]'));

        this.thumbs.forEach((button) => {
          button.addEventListener('click', () => {
            const item = this.items[Number(button.dataset.index)];
            if (item) item.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
        });

        if ('IntersectionObserver' in window && this.items.length) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) this.setActive(this.items.indexOf(entry.target));
              });
            },
            { rootMargin: '-45% 0px -45% 0px' }
          );
          this.items.forEach((item) => this.observer.observe(item));
        }

        this.setActive(0);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      setActive(index) {
        this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
      }
    }

    customElements.define('menina-thumb-rail', MeninaThumbRail);
  })();
  } catch(e) { console.error(e); }
})();

})();
